const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(unauthenticated)/organizations/start.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';
type PendingInvite = z.output<typeof pendingInviteDTOSchema>;
const searchSchema = z.object({
  token: z.string()
});
export const Route = createFileRoute('/(unauthenticated)/organizations/start')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  validateSearch: zodValidator(searchSchema)
});